import Logo from "components/Logo/Logo";
import SocialsList1 from "components/SocialsList1/SocialsList1";
import { CustomLink } from "data/types";
import React from "react";

export interface WidgetFooterMenu {
    id: string;
    title: string;
    menus: CustomLink[];
}

const widgetMenus: WidgetFooterMenu[] = [
    {
        id: "1",
        title: "CryptoVerse",
        menus: [
            {href: "/Markets", label: "Markets"},
            {href: "/Blog", label: "Blog"},
            {href: "/learn", label: "Learn"},
            {href: "/about", label: "About"},
            {href: "/Contact", label: "Support"},
            {href: "/dashboard/root", label: "Dashboard"},
        ],
    },
    {
        id: "2",
        title: "Support",
        menus: [
            {href: "https://docs.google.com/document/d/1C6RKr31FZfaHZSBCELw0FWA0RwD6Pbuu0_y3E9fTElg/edit?usp=sharing", label: "FAQ"},
            {href: "/contact", label: "Contact us"},
            {href: "https://docs.google.com/document/d/1pznGkNB4YRlbSQDjSHY-_NtojWL8nf2yFFnECVW6apw/edit?usp=sharing", label: "Payment Methods"},
            {href: "/", label: "Status"},
            {href: "https://docs.google.com/document/d/19VbY22O0im9h9-xN5O2ZZ--Uw2rgXh27N0mqAdwfaUw/edit?usp=sharing", label: "Cookie Policy"},
            {href: "https://docs.google.com/document/d/1qqFyz9TtpXoxdR7H15XPo_yCKkD1euQIEl30fCP_OlA/edit?usp=sharing", label: "Legal & privacy"},

        ],
    },
    {
        id: "3",
        title: "Learn",
        menus: [
            {href: "https://docs.google.com/document/d/1YmRvxoJ-aSzd50BGuT0R8kWaWAcQsSFP0aggk7p_YsY/edit?usp=sharing", label: "Subscriptions"},
            {href: "/", label: "Crypto Basics"},
            {href: "/", label: "What is Crypto?"},
            {href: "/", label: "What is Blockchain?"},
            {href: "/", label: "what is Web3?"},
            {href: "/", label: "Create a blog post"},

        ],
    },
    {
        id: "4",
        title: "External Links",
        menus: [
            {href: "https://opensea.io/", label: "Opensea"},
            {href: "https://magiceden.io/", label: "Magic Eden"},
            {href: "https://bitcoin.org/en/", label: "Bitcoin"},
            {href: "https://ethereum.org/en/", label: "Ethereum"},
            {href: "https://metamask.io/", label: "Metamask"},
            {href: "https://coinbase.com/", label: "Coinbase"},
        ],
    },
];

const Footer: React.FC = () => {
    const renderWidgetMenuItem = (menu: WidgetFooterMenu, index: number) => {
        return (
            <div key={index} className="text-sm">
                <h2 className="font-semibold text-neutral-700 dark:text-neutral-200">
                    {menu.title}
                </h2>
                <ul className="mt-5 space-y-4">
                    {menu.menus.map((item, index) => (
                        <li key={index}>
                            <a
                                key={index}
                                className="text-neutral-6000 dark:text-neutral-300 hover:text-black dark:hover:text-white"
                                href={item.href}
                            >
                                {item.label}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        );
    };

    return (
        <div className="Footer relative py-16 lg:py-28 border-t border-neutral-200 dark:border-neutral-700">
            <div className="container grid grid-cols-2 gap-y-10 gap-x-5 sm:gap-x-8 md:grid-cols-4 lg:grid-cols-5 lg:gap-x-10 ">
                <div className="grid grid-cols-4 gap-5 col-span-2 md:col-span-4 lg:md:col-span-1 lg:flex lg:flex-col">
                    <div className="col-span-2 md:col-span-1">
                        <Logo />
                    </div>
                    <div className="col-span-2 flex items-center md:col-span-3">
                        <SocialsList1 className="flex items-center space-x-3 lg:space-x-0 lg:flex-col lg:space-y-2.5 lg:items-start" />
                    </div>
                </div>
                {widgetMenus.map(renderWidgetMenuItem)}
            </div>
        </div>
    );
};

export default Footer;
